import { render, staticRenderFns } from "./StCta.vue?vue&type=template&id=e2ee699a"
import script from "./StCta.vue?vue&type=script&lang=ts"
export * from "./StCta.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports